import { useMemo } from 'react';

import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import ShippingCard from './ShippingCard';

import './styles/ShippingAddressSelectorPopup.css';

export default function ShippingAddressSelectorPopup({
  open,
  addresses,
  preferredAddressId,
  selectedAddressId,
  onSelect,
  onClose,
  onAddNewAddress,
  onEditAddress,
}) {
  const sortedAddresses = useMemo(() => {
    if (!Array.isArray(addresses)) {
      return [];
    }

    const withIndex = addresses.map((address, index) => ({ address, index }));

    return withIndex
      .sort((left, right) => {
        const leftPreferred = left.address?._id === preferredAddressId;
        const rightPreferred = right.address?._id === preferredAddressId;

        if (leftPreferred === rightPreferred) {
          return left.index - right.index;
        }

        return leftPreferred ? -1 : 1;
      })
      .map(({ address }) => address);
  }, [addresses, preferredAddressId]);

  function handleSelect(address) {
    if (!onSelect) {
      return;
    }

    onSelect(address);
  }

  return (
    <GenericPopup
      className="shipping-address-selector__popup remove-scrollbar"
      open={open}
      opacity
      onBackgroundClick={onClose}
    >
      <div className="shipping-address-selector__header">
        <Text className="shipping-address-selector__heading">
          Select Address
        </Text>

        <XIcon className="shipping-address-selector__close" onClick={onClose} />
      </div>
      <div className="shipping-address-selector__list remove-scrollbar">
        {sortedAddresses.length === 0 ? (
          <Text className="shipping-address-selector__empty font-size-small" paragraph>
            You have not saved any shipping addresses yet.
          </Text>
        ) : (
          sortedAddresses.map((address) => (
            <ShippingCard
              key={address._id}
              data={address}
              isSelected={selectedAddressId === address._id}
              selectShipping={() => handleSelect(address)}
              setAddressToEdit={(nextAddress) => {
                if (onEditAddress) {
                  onEditAddress(nextAddress);
                }
              }}
            />
          ))
        )}
      </div>
      <div className="shipping-address-selector__footer">
        <ContinueButton
          className="shipping-address-selector__add-button font-size-medium"
          onClick={(event) => {
            event.stopPropagation();
            if (onAddNewAddress) {
              onAddNewAddress(event);
            }
          }}
        >
          Add new address
        </ContinueButton>
      </div>
    </GenericPopup>
  );
}
